import { render, staticRenderFns } from "./AnalyzeSustainability.vue?vue&type=template&id=3521a31c&scoped=true"
import script from "./AnalyzeSustainability.vue?vue&type=script&lang=js"
export * from "./AnalyzeSustainability.vue?vue&type=script&lang=js"
import style0 from "./AnalyzeSustainability.vue?vue&type=style&index=0&id=3521a31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3521a31c",
  null
  
)

export default component.exports